import { withGenericConfig } from "contexts/generic-config-context";
import { ButtonTypes } from "./button-types";
import ProductSignupAndLearnMoreButtons from "./product-signup-and-learn-more-buttons/product-signup-and-learn-more-buttons";
import Label from "./label/label";
import { StyledCardButton } from "./card-button.scss";

const BUTTON_TYPE_TO_COMPONENT = {
  [ButtonTypes.PRODUCT_SIGNUP_AND_LEARN_MORE]: ProductSignupAndLearnMoreButtons,
  [ButtonTypes.LABEL]: Label
};

const CardButton = ({ buttonType, ...buttonConfig }) => {
  const ButtonComponent = BUTTON_TYPE_TO_COMPONENT[buttonType];

  return (
    <StyledCardButton className="card-button-component">
      <ButtonComponent {...buttonConfig} />
    </StyledCardButton>
  );
};

export default withGenericConfig(CardButton);
